import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { datricApi } from '../../../services/api/datric.api';
import { Batch } from '../../../models/batch.model';
import { toastService } from '../../../services/toast.service';

export interface BatchState {
	list: Batch[];
	loading: boolean;
	uploading: boolean;
}

const initialState: BatchState = {
	list: [],
	loading: false,
	uploading: false
};

export const fetchBatches = createAsyncThunk('batch/list', async () => {
	return datricApi.batch.list();
});

export const uploadBatchFile = createAsyncThunk(
	'batch/uploadFile',
	async (payload: { name: string; file: File }, { dispatch, rejectWithValue }) => {
		try {
			const res = await datricApi.batch.createFile(payload.name, payload.file);
			toastService.success('Lote enviado com sucesso');
			dispatch(fetchBatches());
			return res;
		} catch (e: any) {
			toastService.error(typeof e === 'string' ? e : 'Falha ao enviar lote');
			return rejectWithValue(e);
		}
	}
);

export const createBatchFromCpfs = createAsyncThunk(
	'batch/createJson',
	async (payload: { name: string; cpfs: string[] }, { dispatch, rejectWithValue }) => {
		try {
			const res = await datricApi.batch.createJson(payload.name, payload.cpfs);
			toastService.success('Lote criado com sucesso');
			dispatch(fetchBatches());
			return res;
		} catch (e: any) {
			toastService.error(typeof e === 'string' ? e : 'Falha ao criar lote');
			return rejectWithValue(e);
		}
	}
);

export const batchSlice = createSlice({
	name: 'batch',
	initialState,
	reducers: {},
	extraReducers: builder => {
		builder.addCase(fetchBatches.pending, state => {
			state.loading = true;
		});
		builder.addCase(fetchBatches.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload as Batch[];
		});
		builder.addCase(fetchBatches.rejected, state => {
			state.loading = false;
		});
		builder.addCase(uploadBatchFile.pending, state => {
			state.uploading = true;
		});
		builder.addCase(uploadBatchFile.fulfilled, state => {
			state.uploading = false;
		});
		builder.addCase(uploadBatchFile.rejected, state => {
			state.uploading = false;
		});
		builder.addCase(createBatchFromCpfs.pending, state => {
			state.uploading = true;
		});
		builder.addCase(createBatchFromCpfs.fulfilled, state => {
			state.uploading = false;
		});
		builder.addCase(createBatchFromCpfs.rejected, state => {
			state.uploading = false;
		});
	}
});
